import { Injectable } from '@angular/core';
import { DateModel } from 'src/app/shared/models/date.model';
import * as moment from 'moment-jalaali';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  constructor() {
    moment.loadPersian({ dialect: 'persian-modern' });
  }

  today(date: DateModel): void {
    date.day = +moment().format('jDD');
    date.month = +moment().format('jMM');
    date.year = +moment().format('jYYYY');
  }

  todayStringGregorian(): string {
    return moment().format('YYYY-MM-DD');
  }


  getMonthJalaliName(month?: number) {

    return moment().subtract(month ?? 0, 'month').format('jMMMM ');
  }

  getDateTimeFrame(timeFrame: '1h' | '3h' | 'Today' | 'Yesterday' | 'LastMonth' | 'ThisMonth' | 'AWeekAgo' | 'ThreeDaysAgo'): DateModel[] {
    switch (timeFrame) {
      case '1h':
        return [{
          hour: +moment().subtract(moment.duration(1, 'hours')).format('H'),
          minute: +moment().subtract(moment.duration(1, 'hours')).format('m'),
          second: +moment().subtract(moment.duration(1, 'hours')).format('s'),
          month: +moment().subtract(moment.duration(1, 'hours')).format('jM'),
          year: +moment().subtract(moment.duration(1, 'hours')).format('jYYYY'),
          day: +moment().subtract(moment.duration(1, 'hours')).format('jD')
        }, {
          hour: +moment().subtract(moment.duration(0, 'hours')).format('H'),
          minute: +moment().subtract(moment.duration(0, 'hours')).format('m'),
          second: +moment().subtract(moment.duration(0, 'hours')).format('s'),
          month: +moment().subtract(moment.duration(0, 'hours')).format('jM'),
          year: +moment().subtract(moment.duration(0, 'hours')).format('jYYYY'),
          day: +moment().subtract(moment.duration(0, 'hours')).format('jD')
        }] as DateModel[];
      case '3h':
        return [
          {
            hour: +moment().subtract(moment.duration(3, 'hours')).format('H'),
            minute: +moment().subtract(moment.duration(3, 'hours')).format('m'),
            second: +moment().subtract(moment.duration(3, 'hours')).format('s'),
            month: +moment().subtract(moment.duration(3, 'hours')).format('jM'),
            year: +moment().subtract(moment.duration(3, 'hours')).format('jYYYY'),
            day: +moment().subtract(moment.duration(3, 'hours')).format('jD')
          },
          {
            hour: +moment().subtract(moment.duration(0, 'hours')).format('H'),
            minute: +moment().subtract(moment.duration(0, 'hours')).format('m'),
            second: +moment().subtract(moment.duration(0, 'hours')).format('s'),
            month: +moment().subtract(moment.duration(0, 'hours')).format('jM'),
            year: +moment().subtract(moment.duration(0, 'hours')).format('jYYYY'),
            day: +moment().subtract(moment.duration(0, 'hours')).format('jD')
          }
        ] as DateModel[];
      case 'Today':
        return [
          {
            hour: +moment().startOf('day').format('H'),
            minute: +moment().startOf('day').format('m'),
            second: +moment().startOf('day').format('s'),
            month: +moment().format('jM'),
            year: +moment().format('jYYYY'),
            day: +moment().format('jD')
          },
          {
            hour: +moment().endOf('day').format('H'),
            minute: +moment().endOf('day').format('m'),
            second: +moment().endOf('day').format('s'),
            month: +moment().format('jM'),
            year: +moment().format('jYYYY'),
            day: +moment().format('jD')
          }
        ] as DateModel[];
      case 'Yesterday':
        return [{
          hour: +moment().subtract(moment.duration(1, 'days')).startOf('day').format('H'),
          minute: +moment().subtract(moment.duration(1, 'days')).startOf('day').format('m'),
          second: +moment().subtract(moment.duration(1, 'days')).startOf('day').format('s'),
          month: +moment().subtract(moment.duration(1, 'days')).format('jM'),
          year: +moment().subtract(moment.duration(1, 'days')).format('jYYYY'),
          day: +moment().subtract(moment.duration(1, 'days')).format('jD')
        }, {
          hour: +moment().subtract(moment.duration(1, 'days')).endOf('day').format('H'),
          minute: +moment().subtract(moment.duration(1, 'days')).endOf('day').format('m'),
          second: +moment().subtract(moment.duration(1, 'days')).endOf('day').format('s'),
          month: +moment().subtract(moment.duration(1, 'days')).format('jM'),
          year: +moment().subtract(moment.duration(1, 'days')).format('jYYYY'),
          day: +moment().subtract(moment.duration(1, 'days')).format('jD')
        }] as DateModel[];
      case 'ThreeDaysAgo':
        return [{
          hour: +moment().subtract(moment.duration(4, 'days')).startOf('day').format('H'),
          minute: +moment().subtract(moment.duration(4, 'days')).startOf('day').format('m'),
          second: +moment().subtract(moment.duration(4, 'days')).startOf('day').format('s'),
          month: +moment().subtract(moment.duration(4, 'days')).format('jM'),
          year: +moment().subtract(moment.duration(4, 'days')).format('jYYYY'),
          day: +moment().subtract(moment.duration(4, 'days')).format('jD')
        }, {
          hour: +moment().subtract(moment.duration(1, 'days')).endOf('day').format('H'),
          minute: +moment().subtract(moment.duration(1, 'days')).endOf('day').format('m'),
          second: +moment().subtract(moment.duration(1, 'days')).endOf('day').format('s'),
          month: +moment().subtract(moment.duration(1, 'days')).format('jM'),
          year: +moment().subtract(moment.duration(1, 'days')).format('jYYYY'),
          day: +moment().subtract(moment.duration(1, 'days')).format('jD')
        }] as DateModel[];
      case 'AWeekAgo':
        return [{
          hour: +moment().subtract(moment.duration(8, 'days')).startOf('day').format('H'),
          minute: +moment().subtract(moment.duration(8, 'days')).startOf('day').format('m'),
          second: +moment().subtract(moment.duration(8, 'days')).startOf('day').format('s'),
          month: +moment().subtract(moment.duration(8, 'days')).format('jM'),
          year: +moment().subtract(moment.duration(8, 'days')).format('jYYYY'),
          day: +moment().subtract(moment.duration(8, 'days')).format('jD')
        }, {
          hour: +moment().subtract(moment.duration(1, 'days')).endOf('day').format('H'),
          minute: +moment().subtract(moment.duration(1, 'days')).endOf('day').format('m'),
          second: +moment().subtract(moment.duration(1, 'days')).endOf('day').format('s'),
          month: +moment().subtract(moment.duration(1, 'days')).format('jM'),
          year: +moment().subtract(moment.duration(1, 'days')).format('jYYYY'),
          day: +moment().subtract(moment.duration(1, 'days')).format('jD')
        }] as DateModel[];
      case 'LastMonth':
        return [
          {
            hour: +moment().subtract(moment.duration(1, 'months')).startOf('day').format('H'),
            minute: +moment().subtract(moment.duration(1, 'months')).startOf('day').format('m'),
            second: +moment().subtract(moment.duration(1, 'months')).startOf('day').format('s'),
            month: +moment().subtract(moment.duration(1, 'months')).startOf('jMonth').format('jM'),
            year: +moment().subtract(moment.duration(1, 'months')).startOf('jMonth').format('jYYYY'),
            day: +moment().subtract(moment.duration(1, 'months')).startOf('jMonth').format('jD')
          },
          {
            hour: +moment().subtract(moment.duration(1, 'months')).endOf('day').format('H'),
            minute: +moment().subtract(moment.duration(1, 'months')).endOf('day').format('m'),
            second: +moment().subtract(moment.duration(1, 'months')).endOf('day').format('s'),
            month: +moment().subtract(moment.duration(1, 'months')).endOf('jMonth').format('jM'),
            year: +moment().subtract(moment.duration(1, 'months')).endOf('jMonth').format('jYYYY'),
            day: +moment().subtract(moment.duration(1, 'months')).endOf('jMonth').format('jD')
          }
        ] as DateModel[];

      case 'ThisMonth':
        return [
          {
            hour: +moment().startOf('day').format('H'),
            minute: +moment().startOf('day').format('m'),
            second: +moment().startOf('day').format('s'),
            month: +moment().startOf('jMonth').format('jM'),
            year: +moment().startOf('jMonth').format('jYYYY'),
            day: +moment().startOf('jMonth').format('jD')
          },
          {
            hour: +moment().endOf('day').format('H'),
            minute: +moment().endOf('day').format('m'),
            second: +moment().endOf('day').format('s'),
            month: +moment().endOf('jMonth').format('jM'),
            year: +moment().endOf('jMonth').format('jYYYY'),
            day: +moment().endOf('jMonth').format('jD')
          }
        ] as DateModel[];
    }
  }


  previousWeek(): string {
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    return moment(oneWeekAgo).format('YYYY-MM-DD');
  }

  previousMonth(): string {
    const oneMonthAgo = new Date();
    oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
    return moment(oneMonthAgo).format('YYYY-MM-DD');
  }

  todayGregorian(): string {
    return moment().format('YYYY-MM-DD HH:mm:ss');
  }

  startOfDay(date: DateModel): void {
    date.hour = 0;
    date.minute = 0;
    date.second = 0;
  }

  endOfDay(date: DateModel): void {
    date.hour = 23;
    date.minute = 59;
    date.second = 59;
  }

  timeValidate(date: DateModel): boolean {
    return !(
      date.hour === null ||
      date.hour === undefined ||
      date.minute === null ||
      date.minute === undefined ||
      date.second === null ||
      date.second === undefined
    );
  }

  dateValidate(date: DateModel): boolean {
    return !!(date.year && date.month && date.day);
  }

  now(date: DateModel): void {
    date.hour = new Date().getHours();
    date.minute = new Date().getMinutes();
    date.second = new Date().getSeconds();
  }

  convertDateToString(date: DateModel, format = 'YYYY-MM-DD HH:mm:ss'): string | undefined {
    if (this.dateValidate(date) && this.timeValidate(date)) {
      return moment(
        `${date.year}-${date.month}-${date.day} ${date.hour}:${date.minute}:${date.second}`,
        'jYYYY-jMM-jDD HH:mm'
      ).format(format);
    } else if (this.dateValidate(date)) {
      return moment(`${date.year}-${date.month}-${date.day}`, 'jYYYY-jMM-jDD').format(format);
    }
    return undefined;
  }

  convertDateToStringGregorian(date: DateModel, format = 'YYYY-MM-DD'): string {
    return moment(
      `${date.year}-${date.month}-${date.day} ${date.hour}:${date.minute}:${date.second}`,
      'jYYYY-jMM-jDD'
    ).format(format);
  }

  convertStringDateToDate(date: string): DateModel {
    const dateModel = {} as DateModel;
    dateModel.year = +moment(date, 'YYYY-MM-DD HH:mm:ss').format('jYYYY');
    dateModel.month = +moment(date, 'YYYY-MM-DD HH:mm:ss').format('jMM');
    dateModel.day = +moment(date, 'YYYY-MM-DD HH:mm:ss').format('jDD');
    return dateModel;
  }
  convertStringDateTimeToDateTimme(date: string): DateModel {
    const dateModel = {} as DateModel;
    dateModel.year = +moment.utc(date, 'YYYY-MM-DD HH:mm:ss').format('jYYYY');
    dateModel.month = +moment.utc(date, 'YYYY-MM-DD HH:mm:ss').format('jMM');
    dateModel.day = +moment.utc(date, 'YYYY-MM-DD HH:mm:ss').format('jDD');
    dateModel.minute = +moment.utc(date, 'YYYY-MM-DD HH:mm:ss').local().format('mm');
    dateModel.hour = +moment.utc(date, 'YYYY-MM-DD HH:mm:ss').local().format('HH');
    dateModel.second = +moment.utc(date, 'YYYY-MM-DD HH:mm:ss').local().format('ss');
    return dateModel;
  }

  convertDateToSqlDateUTC(date: Date) {
    return moment(date).utc(false).format('YYYY-MM-DD HH:mm:ss');
  }

  convertDateModelToDateWithTimezone(model: DateModel): Date {
    model = { ...model, second: 0, timeIsDisabled: false };
    let jalaaliDate = moment(`${model.year}-${model.month}-${model.day} ${model.hour?.toFixed(2)}:${model.minute?.toFixed(2)}:${model.second?.toFixed(2)}`, 'jYYYY-jMM-jDD HH:mm:ss');
    return jalaaliDate.toDate();
  }

  convertGregorianToJalali(date: string): string {
    return moment(date, 'YYYY-MM-DD').format('jYYYY-jMM-jDD');
  }


}
